import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getCustomerAddressEditById = createAsyncThunk(
  "customerAddressEditByIdList/getCustomerAddressEditById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/customerAddress/edit`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const customerAddressEditByIdSlice = createSlice({
  name: "customerAddressEditByIdList",
  initialState: {
    loading: false,
    customerAddressEditByIdListData: null,
    error: null,
  },
  reducers: {
    ResetCustomerAddressEditByIdState: (state) => {
      state.loading = false;
      state.customerAddressEditByIdListData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerAddressEditById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerAddressEditById.fulfilled, (state, action) => {
        state.loading = false;
        state.customerAddressEditByIdListData = action.payload;
      })
      .addCase(getCustomerAddressEditById.rejected, (state, action) => {
        state.loading = false;
        state.customerAddressEditByIdListData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetCustomerAddressEditByIdState } = customerAddressEditByIdSlice.actions;
export default customerAddressEditByIdSlice.reducer;
